import { Select, TextField } from '@components/base/inputs';
import { VStack } from '@components/base/layout';

interface GenerateReportConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

export function GenerateReportConfigPanel({
  getValue,
  setValue,
}: Readonly<GenerateReportConfigPanelProps>) {
  return (
    <VStack gap={4}>
      <Select
        label="Report Type"
        required
        options={[
          { value: 'csv', label: 'CSV' },
          { value: 'json', label: 'JSON' },
          { value: 'pdf', label: 'PDF' },
        ]}
        value={(getValue('config_report_type') as string) ?? ''}
        onChange={(value) => setValue('config_report_type', value)}
      />

      <TextField
        label="Filename"
        required
        placeholder="e.g. claims-export"
        value={(getValue('config_filename') as string) ?? ''}
        onChange={(e) => setValue('config_filename', e.target.value)}
      />

      <TextField
        label="Data Key"
        required
        placeholder="e.g. claims_data"
        helperText="Context key containing the array data for the report."
        value={(getValue('config_data_key') as string) ?? ''}
        onChange={(e) => setValue('config_data_key', e.target.value)}
      />

      <TextField
        label="Storage Disk"
        placeholder="local"
        helperText="Optional. Defaults to 'local'."
        value={(getValue('config_storage_disk') as string) ?? ''}
        onChange={(e) => setValue('config_storage_disk', e.target.value)}
      />

      <TextField
        label="Storage Path"
        placeholder="reports/"
        helperText="Optional. Defaults to 'reports/'."
        value={(getValue('config_storage_path') as string) ?? ''}
        onChange={(e) => setValue('config_storage_path', e.target.value)}
      />
    </VStack>
  );
}
